export const matchColorsBanner = (color) => {
  switch (color) {
    case '#000000':
    case '#BD113A':
    case '#CC0100':
    case '#BC6C0A':
    case '#29754F':
    case '#3E6CB3':
    case '#2A4878':
    case '#5209ED':
      return '#FFFFFF';
    case '#FFFFFF':
      return '#000000'
    default:
      return '#102640';
  }
}
